"use client";

import { CompanyDemoToolbar } from "./CompanyDemoToolbar";

/** Company demo strip — rendered in the AniOS workspace banner (below the workspace bar). */
export function CompanyDemoOsBar() {
  return <CompanyDemoToolbar className="w-full" />;
}
